// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
/**
 * Google Workspace service-account + Domain-Wide Delegation registration guide.
 * Two consoles are involved — GCP for the key and the APIs, the Workspace Admin
 * console for delegation — and a step done in the wrong one is the usual reason a
 * registration looks complete and then fails on the first call.
 */
export const GOOGLE_WORKSPACE_SERVICE_ACCOUNT_STEPS = [
    {
        title: 'Create the service account key (JSON)',
        body: 'Google Cloud console → IAM & Admin → Service Accounts → your service account → Keys → Add key → Create new key → JSON.\n' +
            'The downloaded file starts with "type": "service_account" and contains a client_email and a long private_key. Paste the whole file into Credentials on this form — not just one field from it.',
    },
    {
        title: 'Enable each Google API you will call',
        body: 'Google Cloud console → APIs & Services → Library → find the API → Enable. Do this for every surface the app touches: Google Drive API for Drive, Gmail API for mail, Google Calendar API for calendars, Google Sheets API for spreadsheets.\n' +
            'Each API is enabled separately. A scope that looks correct still fails if its API was never enabled on the project.',
    },
    {
        title: 'Authorize domain-wide delegation',
        body: 'Google Admin console (admin.google.com, as a super-admin) → Security → Access and data control → API controls → Domain-wide delegation → Add new.\n' +
            'Use the service account\'s numeric Client ID — the "Unique ID" on the service account in GCP, not its client_email address. An email pasted here is silently accepted and never matches.',
    },
    {
        title: 'Keep the scopes identical in both places',
        body: 'The scope list you authorize in the Admin console must match the scopes you enter on this form exactly, string for string — https://www.googleapis.com/auth/drive.readonly is a different scope from https://www.googleapis.com/auth/drive.\n' +
            'A scope Greenlight requests that the Admin console has not authorized fails the whole call, not just that scope.',
    },
    {
        title: 'Confirm who the calls run as',
        body: 'When a signed-in user triggers a call, Greenlight impersonates that user — so they must exist in this Workspace domain, and Google applies their own permissions. A user outside the domain cannot be impersonated.\n' +
            'Calls with no signed-in user run as the service account itself, which sees only what has been shared with its client_email directly (a shared Drive folder, for example).',
    },
];
//# sourceMappingURL=google-workspace-service-account-guide.js.map